import { Text } from '~/components/ui/Text';
import { rage, useObservable } from '~/rage';
import battery from '../../assets/icons/battery.svg';
import mobile from '../../assets/icons/mobile.svg';
import {
	StyledCamera,
	StyledContainer,
	StyledDynamicIsland,
	StyledRightContainer,
} from './TopRow.styled';

const TopRow = () => {
	const time = useObservable(rage.game.getRealTime());

	return (
		<StyledContainer>
			<Text style={{ fontSize: 14, fontWeight: 500, color: '#ffffff' }}>
				{time.time}
			</Text>
			<StyledDynamicIsland>
				<StyledCamera />
			</StyledDynamicIsland>
			<StyledRightContainer>
				<img src={mobile} alt="mobile" />
				<img src={battery} alt="battery" />
			</StyledRightContainer>
		</StyledContainer>
	);
};

export { TopRow };
